import Dialog from '@stimulus-components/dialog'

export default class extends Dialog {
  static targets = ["dialog", "overlay"]

  connect() {
    super.connect()

    this.handleResize = this.handleResize.bind(this)
    window.addEventListener('resize', this.handleResize)

    this.dialogTarget.addEventListener('close', () => {
      this.cleanup()
    })
  }

  disconnect() {
    super.disconnect()
    window.removeEventListener('resize', this.handleResize)
  }

  handleResize() {
    if (window.innerWidth >= 1024 && this.dialogTarget.open) {
      this.close()
    }
  }

  open(event) {
    super.open(event)
    document.body.style.overflow = 'hidden'
    this.overlayTarget.classList.remove('hidden')
    this.dialogTarget.classList.remove('hidden')
  }

  close(event) {
    super.close(event)
    this.cleanup()
  }

  cleanup() {
    document.body.style.overflow = ''
    this.overlayTarget.classList.add('hidden')
    this.dialogTarget.classList.add('hidden')
  }

  backdropClose(event) {
    if (event.target === this.overlayTarget) {
      this.close(event)
    }
  }

  closeOnOverlayClick(event) {
    if (event.target === this.overlayTarget) {
      this.close(event)
    }
  }

  stopPropagation(event) {
    event.stopPropagation()
  }
}
